export enum ActionTypes {
  GET_REPORTS_COUNT = '[Report] GetReportsCount',
}

export class GetReportsCount {
  static readonly type = ActionTypes.GET_REPORTS_COUNT;
}
